// extracted by mini-css-extract-plugin
export var actionButton = "_pr-0";
export var actionMenuContainer = "_pr-i";
export var bubble = "_pr-2";
export var bubbleActionMenu = "_pr-j";
export var bubbleContext = "_pr-6";
export var bubbleItems = "_pr-7";
export var customer = "_pr-3";
export var divider = "_pr-8";
export var fileList = "_pr-9";
export var hiddenComment = "_pr-o";
export var infoAbove = "_pr-a";
export var internal = "_pr-4";
export var lightActionButton = "_pr-1";
export var link = "_pr-b";
export var merchant = "_pr-5";
export var message = "_pr-c";
export var profilePicture = "_pr-e";
export var quillToolbarContainer = "_pr-f";
export var senderDate = "_pr-g";
export var senderDateCustomer = "_pr-h";
export var senderName = "_pr-d";
export var time = "_pr-k";
export var uploadedImage = "_pr-l";
export var username = "_pr-m";
export var xsmall = "_pr-n";